/**
 * Mantenimiento y auditoría en la misma pantalla.
 */
import React from 'react';
import { ink, studio } from './studioUi';
import MaintenancePanel from './MaintenancePanel';
import AuditPanel from './AuditPanel';

const OpsHub = ({
    fetchWithAuth,
    API_URL,
    API_URL_INTERNAL,
    users,
    dashboards,
    cargarTodo,
    userRole,
    userPermissions,
    setSubView,
}) => {
    const canMaint = Boolean(userPermissions.maintenance_execute_tasks);
    const canAudit = Boolean(userPermissions.admin_panel_audit_view || userPermissions.admin_panel_comprehensive_audit_view);

    return (
        <div style={studio.page}>
            <div style={studio.header}>
                <div>
                    <p style={studio.kicker}>Administración</p>
                    <h2 style={studio.title}>Mantenimiento</h2>
                    <p style={studio.subtitle}>
                        Repara datos, cierra periodos de medición y revisa inconsistencias de reportes y permisos.
                    </p>
                </div>
            </div>

            {canMaint && (
                <MaintenancePanel
                    fetchWithAuth={fetchWithAuth}
                    API_URL_INTERNAL={API_URL_INTERNAL || API_URL}
                    users={users}
                    dashboards={dashboards}
                    cargarTodo={cargarTodo}
                    userRole={userRole}
                    userPermissions={userPermissions}
                />
            )}

            {canAudit && (
                <section style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                    <div>
                        <h3 style={{ margin: 0, fontSize: '1.05rem', fontWeight: 600, color: ink.text }}>Auditoría</h3>
                        <p style={{ ...studio.hint, marginTop: 4 }}>
                            Inconsistencias de reportes, permisos y responsables.
                        </p>
                    </div>
                    <AuditPanel
                        API_URL={API_URL || API_URL_INTERNAL}
                        fetchWithAuth={fetchWithAuth}
                        userPermissions={userPermissions}
                        setSubView={setSubView}
                        cargarTodo={cargarTodo}
                    />
                </section>
            )}
        </div>
    );
};

export default OpsHub;
